import type { GetIngestorsResponseAction } from 'client/js/redux/domains/EmailIngestor/actions/getIngestors.action';
import type { GetEmailIngestorByIdResponseAction } from './getIngestorById.action';
import type { PatchEmailIngestorResponseAction } from './patchEmailIngestor.action';
import type { SetupEmailIngestorResponseAction } from './setupEmailIngestor.action';
export * from './getIngestors.action';
export * from './getIngestorById.action';
export * from './setupEmailIngestor.action';
export * from './patchEmailIngestor.action';

export type EmailIngestorAction =
  | GetIngestorsResponseAction
  | SetupEmailIngestorResponseAction
  | PatchEmailIngestorResponseAction
  | GetEmailIngestorByIdResponseAction;
